module.exports = __webpack_public_path__ + "static/media/mra_mdImg.cb45453e.jpg";